// extracted by mini-css-extract-plugin
module.exports = {"bpXSmall":"360px","bpSmall":"576px","bpMedium":"768px","bpLarge":"999px","bpXLarge":"1440px","modalCard":"style_modalCard__28AV9"};